import React, {useEffect, useRef, useState} from "react"
import {Form} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {maxLength, PasswordValidation, Required} from "../../../utils/patterns";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {useLocation, useNavigate} from "react-router";
import PasswordInput from "../../../components/common/password-field/PasswordInput";
import Heading from "../../../components/dashboard/heading-component/Heading";
import {UserAuthService} from "../../../services/user-auth-api.service";
import {notification} from "antd";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {useUser} from "../../../providers/UserContext";

export default function ChangePassword() {
    const [loader, setLoader] = useState(false)
    const { state } = useLocation();
    const [otpCode, setOtpCode] = useState(state?.otp)
    const navigate = useNavigate()
    const {resetVerified, setResetVerified} = useUser()
    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors},
        control,
        clearErrors,
        watch
    } = useForm({
        mode: 'onChange',
    })
    const password = useRef({})
    password.current = watch('password', '')

    const onSubmit = async (data) => {
        setLoader(true)
        const result = await UserAuthService.ResetPasswordApi(state?.email, data.password, data.cpassword)

        if (result?.data?.data?.status) {
            notification.success({
                message: "Success",
                description: `${result?.data?.data?.message}`,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 2,
            });
            navigate("/login");
            setResetVerified(true)
        }
        setLoader(false)
    }



    useEffect(()=>{

        if (state === null) {
            navigate('/forgot-password');
        } else if (!state?.otp) {
            navigate('/forgot-password');
        }

    })

    useEffect(()=>{
        if (resetVerified) {
            navigate('/forgot-password');
        }
    })

    return(
        <div className={'login'}>
            <Heading back={true} heading={'Reset Password'}/>
            <h5>Your new password must be different from the previously used passwords. </h5>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'dfields'}>
                    <Controller
                        name="password"
                        defaultValue={''}
                        control={control}
                        rules={{required: Required, pattern:PasswordValidation, maxLength: maxLength(100)}}
                        render={({field: {name, ...field}}) => (
                            <PasswordInput
                                placeholder={'Enter new password here'}
                                label={'New Password'}
                                field={field}
                                errors={errors.password}
                                className={'required'}
                            />
                        )}
                    />
                </div>
                <div className={'dfields'}>
                    <Controller
                        name="cpassword"
                        defaultValue={''}
                        control={control}
                        rules={{
                            required: Required,
                            validate: (value) => value == password.current || 'The password does not match',
                        }}
                        render={({field: {name, ...field}}) => (
                            <PasswordInput
                                placeholder={'Re-enter new password here'}
                                label={'Re-enter New Password'}
                                field={field}
                                errors={errors.cpassword}
                                className={'required'}
                            />
                        )}
                    />
                </div>

                <div className={'dfields mt-4'}>
                    <ThemeButton
                        text={'Update'}
                        className={'btn-light-lg'}
                        type={'submit'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}